// extracted by mini-css-extract-plugin
export var active = "_40-7";
export var container = "_40-0";
export var evenWidth = "_40-4";
export var large = "_40-5";
export var outlet = "_40-8";
export var slide = "_40-2";
export var small = "_40-6";
export var tab = "_40-3";
export var tabs = "_40-1";